export const getLatLngFromScreen = (map, x, y) => {
    if (!map) return null;

    const mapDiv = map.getDiv();
    const bounds = mapDiv.getBoundingClientRect();

    const relativeX = x - bounds.left;
    const relativeY = y - bounds.top;

    const mapBounds = map.getBounds();
    const ne = mapBounds.getNorthEast();
    const sw = mapBounds.getSouthWest();

    const lat = sw.lat() + (ne.lat() - sw.lat()) * (1 - relativeY / bounds.height);
    const lng = sw.lng() + (ne.lng() - sw.lng()) * (relativeX / bounds.width);

    return new google.maps.LatLng(lat, lng);
};

export const getMobileDragOffset = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const clientX = event.clientX || (event.touches && event.touches[0].clientX);
    const clientY = event.clientY || (event.touches && event.touches[0].clientY);

    return {
        x: clientX - centerX,
        y: clientY - centerY,
    };
};

export const getMobileCrosshairPosition = (event, mobileDragOffset) => {
    const clientX = event.clientX || (event.touches && event.touches[0].clientX);
    const clientY = event.clientY || (event.touches && event.touches[0].clientY);

    const x = clientX - mobileDragOffset.x;
    const y = clientY - mobileDragOffset.y;

    return {x, y};
};
